// @module MHI.ItemPriceHistory.ItemPriceHistory
define('MHI.ItemPriceHistory.ItemPriceHistory.View'
,	[
	'mhi_itempricehistory_itempricehistory.tpl'
	
	,	'MHI.ItemPriceHistory.ItemPriceHistory.SS2Model'
	
	,	'Backbone'
    ]
, function (
	mhi_itempricehistory_itempricehistory_tpl
	
	,	ItemPriceHistorySS2Model
	
	,	Backbone
)
{
    'use strict';

	// @class MHI.ItemPriceHistory.ItemPriceHistory.View @extends Backbone.View
	return Backbone.View.extend({

		template: mhi_itempricehistory_itempricehistory_tpl

	,	initialize: function (options) {

			/*  Uncomment to test backend communication with an example service
				(you'll need to deploy and activate the extension first)
			*/
			this.container = options.container;
			this.model = new ItemPriceHistorySS2Model();
			var pdp = this.container.getComponent('PDP');
			var itemInfo = pdp.getItemInfo();
			
			var itemid = itemInfo.item.itemid;
			
			
			var params = {};
			
			params.data = {};
			params.data.itemid = itemid;
			var self = this;
			this.message = [];
			this.model.fetch(params).then(function(result) {
				
				self.message = result.message || [];
				self.render();

			});
			
			
		}

	

		//@method getContext @return MHI.ItemPriceHistory.ItemPriceHistory.View.Context
	,	getContext: function getContext()
		{
			//@class MHI.ItemPriceHistory.ItemPriceHistory.View.Context
			
			
			var hasHistory = this.message.length > 0 && this.message[0].lastPurchaseDate;
			
			return {
				message: this.message,
				hasHistory: hasHistory
			};
		}
	});
});
